import { useState } from "react";

export default function TooltipButton({ icon: Icon, tooltip, onClick, disabled, variant = "gray" }) {
  const [showTooltip, setShowTooltip] = useState(false);
  const variantClasses = {
    gray: "hover:opacity-70",
    purple: "hover:opacity-70 text-purple-600 hover:text-purple-700",
    red: "hover:opacity-70 text-red-600 hover:text-red-700",
    green: "hover:opacity-70 text-green-600 hover:text-green-700",
    blue: "hover:opacity-70 text-blue-600 hover:text-blue-700",
  };
  return (
    <div className="relative">
      <button
        onClick={onClick}
        disabled={disabled}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        className={`p-2 border border-black/30 rounded-md transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed ${variantClasses[variant]}`}
      >
        <Icon size={16} />
      </button>
      {showTooltip && !disabled && (
        <div className="absolute bottom-full mb-2 right-0 bg-white text-black text-xs px-3 py-1.5 rounded-md whitespace-nowrap z-50 shadow-lg">
          {tooltip}
          <div className="absolute top-full right-4 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-900" />
        </div>
      )}
    </div>
  );
}